import { Languages } from 'lucide-react';
import { LOCALES, setLocale, useT } from '../lib/i18n';

/**
 * Which language Ìran speaks to you in — distinct from the language your family
 * is keeping alive, which lives in LanguageSwitcher next to it.
 *
 * Hidden entirely while English is the only reviewed catalogue. A dropdown with
 * one option is furniture: it takes up space on every page and tells a family
 * nothing. It appears by itself the moment a second catalogue is approved.
 */
export function InterfaceLanguage() {
  const { t, locale } = useT();
  if (LOCALES.length < 2) return null;

  return (
    <label className="lang-chip" title={t('language.interfaceTitle')}>
      <Languages size={15} strokeWidth={1.75} aria-hidden="true" />
      <span className="sr-only">{t('language.interface')}</span>
      <select value={locale} onChange={(e) => void setLocale(e.target.value)}>
        {LOCALES.map((l) => (
          // Each language named in itself. Someone looking for their own
          // language scans for the word they would write, not its English name.
          <option key={l.code} value={l.code} lang={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
